module.exports = __webpack_public_path__ + "img/logo.7930edb0.png";